import R from 'ramda'

const FACEBOOK_ONETIME_OPTIN_DISPLAY_TYPE = 'Opt FB User in'
const FACEBOOK_ONETIME_OPTIN_WIDGET_TYPE = 'FB_OPT_IN_ONE_TIME'

const isFacebookOneTimeWidgetOptInAction = R.propEq(
  'type',
  FACEBOOK_ONETIME_OPTIN_WIDGET_TYPE
)

const convertFacebookOptInToFormAction = R.applySpec({
  type: R.always(FACEBOOK_ONETIME_OPTIN_DISPLAY_TYPE)
})

export { isFacebookOneTimeWidgetOptInAction, convertFacebookOptInToFormAction }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/facebook/widget-to-form/facebook-onetime-optin.js